













































import ActivityTimeLineItemDocumentCard from "@/components/partner/ActivityTimeLineItemDocumentCard.vue";
import ReportBaseTimeLine from "@/components/partner/ReportBaseTimeLine.vue";
import SharedContentAccessDescription from "@/components/partner/SharedContentAccessDescription.vue";
import SharedContentAccessExpired from "@/components/partner/SharedContentAccessExpired.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { handleError } from "@/lib/utility/handleError";
import reportService from "@/services/mrfiktiv/services/reportService";
import sharedContentService from "@/services/mrfiktiv/services/sharedContentService";
import {
  MrfiktivSharedContentViewmodelGen,
  MrfiktivSharedReportViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportWithBanner,
    ReportBaseTimeLine,
    Tooltip,
    SharedContentAccessDescription,
    SharedContentAccessExpired,
    ActivityTimeLineItemDocumentCard
  }
})
export default class SharedContentView extends Vue {
  loading = false;

  expired = false;

  sharedContent: MrfiktivSharedContentViewmodelGen | null = null;
  report: MrfiktivSharedReportViewmodelGen | null = null;

  get ResourceEnum() {
    return ResourceEnum;
  }

  get accessToken() {
    return this.$route.params.token;
  }

  get partner() {
    return ReportModule.partner;
  }

  get user() {
    return this.sharedContent?.user;
  }

  async mounted() {
    this.loading = true;
    this.expired = false;

    try {
      this.sharedContent = await sharedContentService.access(this.partner.id, this.accessToken);

      for (const ref of this.sharedContent.refs) {
        if (ref.refType === ResourceEnum.REPORT) {
          this.report = await reportService.getReportBySharedAccessToken(this.partner.id, ref.refId, this.accessToken);
        }
      }
    } catch (e) {
      if ((e as any).message === "Sharing document expired") {
        this.expired = true;
      } else {
        handleError(e);
      }
    } finally {
      this.loading = false;
    }
  }

  print() {
    window.print();
  }
}
